import { Component, Input } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {

	header: string = 'Are you sure?';
  message: string = '';
  yesBtn: string = 'Yes';
  yesBtnClass: string = 'btn-emphasis';
  noBtn: string = 'Cancel';
  noBtnClass: string = 'btn-outline-alt-1';
  confirm: any;

  constructor(public modal: BsModalRef) { }

}



// WEBPACK FOOTER //
// ./client/app/global/confirm-dialog/confirm-dialog.component.ts